import React from 'react';

const Mobile: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'end',
        justifyContent: 'center',
        height: '50vh',
        textAlign: 'center',
        color: 'var(--text-primary)',
      }}
    >
      <span>Please open 'Vibo DJ' with a computer</span>
    </div>
  );
};

export default Mobile;
